<div class="container-fluid">
    <div align="right">
        <div class="row">
            <div class="col-lg-12" style="min-height: 35px;">
                <app-botao-ajuda [manual]="'manual4_3'" [titleAjuda]="'Ajuda - Consultar Máquina'"></app-botao-ajuda>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="container-fluid">
            <form [formGroup]="form" novalidate (ngSubmit)="pesquisar(null)" (keyup.enter)="pesquisar(null)">
                <div class="row">
                    <div class="col-12">
                        <mat-accordion class="full-width filtros">
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        Filtros
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div class="row">

                                    <div class="col-4">
                                        <mat-form-field class="full-width">
                                            <input matInput [matDatepicker]="dtInicial" placeholder="Data Inicial"
                                                formControlName="dtInicial" name="dtInicial"
                                                (input)="atualizaFiltro(form.get('dtInicial'))" />
                                            <mat-datepicker-toggle matSuffix [for]="dtInicial"></mat-datepicker-toggle>
                                            <mat-datepicker #dtInicial></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-4">
                                        <mat-form-field class="full-width">
                                            <input matInput [matDatepicker]="dtFinal" placeholder="Data Final"
                                                formControlName="dtFinal" name="dtFinal"
                                                (input)="atualizaFiltro(form.get('dtFinal'))" />
                                            <mat-datepicker-toggle matSuffix [for]="dtFinal"></mat-datepicker-toggle>
                                            <mat-datepicker #dtFinal ngDefaultControl (input)="atualizaFiltro($event)">
                                            </mat-datepicker>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-2">
                                        <button mat-mini-fab color="primary">
                                            <i class="material-icons">search</i>
                                        </button>
                                    </div>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<div class="container-fluid">

    <div class="consulta">
        <div class="container-table">

            <table mat-table [dataSource]="dataSource" *ngIf="!isFetching">

                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef class="text-center">
                        <Strong>Ações</Strong>
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                        <div>
                            <button mat-mini-fab *ngIf="row.estadoMaquina == 'Ativo'"
                                (click)="direcionarEdicao(row,$event)" title="Editar" id="deactivated">
                                <img class="img-fluid" src="assets/icons/edit.png" width="18px" />
                            </button>
                            <button mat-mini-fab disabled *ngIf="row.estadoMaquina != 'Ativo'" id="deactivated">
                            </button>
                            <button mat-mini-fab (click)="alterarEstadoMaquina(row,$event)" title="Alterar estado"
                                style="margin-right: 7px;">
                                <img class="img-fluid" src="assets/icons/change.png" width="18px" />
                            </button>
                            <button mat-mini-fab (click)="exibirHistorico(row,$event)" title="Exibir Histórico">
                                <img class="img-fluid" src="assets/icons/historico.png" width="18px" />
                            </button>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="nomeMaquina">
                    <th mat-header-cell *matHeaderCellDef class="text-center"> Nome </th>
                    <td mat-cell *matCellDef="let element" class="text-center"> {{element.nomeMaquina}} </td>
                </ng-container>

                <ng-container matColumnDef="dtInicial">
                    <th mat-header-cell *matHeaderCellDef class="text-center"> Data de Cadastro </th>
                    <td mat-cell *matCellDef="let element" class="text-center"> {{element.dtInicial}} </td>
                </ng-container>

                <ng-container matColumnDef="dtExpiracao">
                    <th mat-header-cell *matHeaderCellDef class="text-center"> Data de Expiração </th>
                    <td mat-cell *matCellDef="let element" class="text-center"> {{element.dtFinal}} </td>
                </ng-container>

                <ng-container matColumnDef="estadoMaquina">
                    <th mat-header-cell *matHeaderCellDef class="text-center"> Estado </th>
                    <td mat-cell *matCellDef="let element" class="text-center"> {{element.estadoMaquina}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="cursor"></tr>

            </table>

            <mat-paginator class="paginacao" [pageSizeOptions]="[10, 15, 20]" [length]="length" [pageIndex]="pageIndex"
                showFirstLastButtons (page)="pesquisar($event)" [disabled]="paginacao"></mat-paginator>

        </div>
    </div>
</div>